(() => {
  'use strict';

  const widgetSelector = '#judgeme_product_reviews';
  const sortSelector = 'select.jdgm-sort-dropdown';
  const extraImageClass = 'lz-judgeme-extra-image';
  let defaultSortApplied = false;
  let updateQueued = false;

  function updateReviews() {
    updateQueued = false;

    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    // Judge.me inserts its widget after the theme scripts have loaded.
    if (!defaultSortApplied) {
      const sort = widget.querySelector(sortSelector);
      if (sort && sort.querySelector('option[value="pictures_first"]')) {
        defaultSortApplied = true;
        if (sort.value !== 'pictures_first') {
          sort.value = 'pictures_first';
          sort.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    widget.querySelectorAll('.jm-review-item').forEach((review) => {
      review.querySelectorAll('.jm-media-thumbnail-list__thumbnail').forEach((image, index) => {
        const wrapper = image.closest('.jm-box');
        if (wrapper && review.contains(wrapper)) {
          wrapper.classList.toggle(extraImageClass, index > 0);
        }
      });
    });
  }

  function queueUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    requestAnimationFrame(updateReviews);
  }

  function start() {
    function watchWidget(widget) {
      new MutationObserver(queueUpdate).observe(widget, {
        childList: true,
        subtree: true
      });
      queueUpdate();
    }

    const widget = document.querySelector(widgetSelector);
    if (widget) {
      watchWidget(widget);
      return;
    }

    const discoveryObserver = new MutationObserver(() => {
      const loadedWidget = document.querySelector(widgetSelector);
      if (!loadedWidget) return;
      discoveryObserver.disconnect();
      watchWidget(loadedWidget);
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
